import type { IDiscountCouponBase } from "./DiscountCouponBase";
import { DiscountCouponBase, DiscountCouponType } from "./DiscountCouponBase";

import * as css from "./DiscountCouponCode.module.css";

export interface IDiscountCouponCode extends IDiscountCouponBase {
    couponCode: string;
}

export class DiscountCouponCode extends DiscountCouponBase<IDiscountCouponCode> {
    protected couponType = DiscountCouponType.Code;

    protected renderCoupon = () => <div className={css.discountCouponCode}>{this.props.couponCode}</div>;
}
